export default "__VITE_ASSET__HcbLFe0R__"